import { render, staticRenderFns } from "./AutocompleteProfession.vue?vue&type=template&id=54c6dc3c"
import script from "./AutocompleteProfession.vue?vue&type=script&lang=js"
export * from "./AutocompleteProfession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports